import { ImageTypes, ImageWrapperProps } from "./interface";
import Picture from "./components/Picture";
import Image from "./components/Image";

const ImageWrapper = (props: ImageWrapperProps) => {
    const { imageType } = props;

    switch (imageType) {
        case ImageTypes.Picture:
            return <Picture {...props} />;
        case ImageTypes.Image:
            return <Image {...props} />;
    }
};

export default ImageWrapper;
